// extracted by mini-css-extract-plugin
module.exports = {"root":"OpenInNewTab_root__3lpUe","icon":"OpenInNewTab_icon__3qSYG"};